import { RouterProvider } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Toaster } from 'sonner';
import { AppProviders } from '@app/providers';
import { router } from '@app/router';
import { NUQS_ADAPTER_OPTIONS, useNewVersionNotice } from '@shared/lib';

/**
 * Cockpit Application Root
 *
 * Minimal root component that:
 * - Composes providers (AppProviders)
 * - Renders the data router (RouterProvider)
 * - Configures toaster notifications
 * - Tells open tabs when a newer version has been deployed
 *
 * Die Provider stehen ueber dem Router, nicht darunter: Sie sind router-frei,
 * und der Router braucht sie (Sitzung, Query-Cache, Bestaetigungsdialog) in
 * jeder Route.
 *
 * `NuqsAdapter` reicht nur den Zugang zum Router weiter (siehe
 * `use-url-state.ts`) — er ruft selbst keinen Router-Haken auf und darf
 * deshalb ausserhalb von `RouterProvider` stehen.
 *
 * Warum `NUQS_ADAPTER_OPTIONS` und kein Literal: siehe `use-url-state.ts`.
 */
function App() {
  return (
    <AppProviders>
      <div className="min-h-screen bg-background">
        <NuqsAdapter defaultOptions={NUQS_ADAPTER_OPTIONS}>
          <RouterProvider router={router} />
        </NuqsAdapter>
        <Toaster richColors position="bottom-right" />
        <NewVersionNotice />
      </div>
    </AppProviders>
  );
}

/**
 * Mounted next to the toaster it reports through. Offers a reload when a
 * newer build has been deployed while this tab was open.
 */
function NewVersionNotice() {
  useNewVersionNotice();
  return null;
}

export default App;
